function addSoundToSprite(sound, sprite, vm) {
  if (!vm || !sprite || !sound) {
    console.error("Invalid VM, sprite, or sound.");
    return;
  }

  const audioEngine = vm.runtime.audioEngine;
  //check if sprite already has a sound with the same name, if so, return
  if (sprite.sounds.find((s) => s.name === sound.name)) {
    console.warn(
      `Sprite "${sprite.name}" already has a sound with the name "${sound.name}"`
    );
    return;
  }
  // Ensure the audio engine is available
  if (!audioEngine) {
    console.error("Audio engine not available in the VM.");
    return;
  }

  // Decode the sound and create a soundPlayer
  audioEngine
    .decodeSoundPlayer({
      name: sound.name,
      data: new Uint8Array(sound.asset.data), // Pass the sound data as Uint8Array
    })
    .then((soundPlayer) => {
      if (!soundPlayer) {
        console.error(`Failed to decode soundPlayer for sound: ${sound.name}`);
        return;
      }

      // Assign soundId from the created soundPlayer
      sound.soundId = soundPlayer.id;

      // Ensure the sprite has a soundBank
      if (!sprite.soundBank) {
        sprite.soundBank.soundPlayers = {};
      }

      // Add the soundPlayer to the sprite's soundBank
      sprite.soundBank.soundPlayers[sound.soundId] = soundPlayer;

      // Add the sound to the sprite's sounds array
      sprite.sounds.push({
        name: sound.name,
        assetId: sound.assetId,
        dataFormat: sound.dataFormat,
        rate: sound.rate,
        sampleCount: sound.sampleCount,
        md5: sound.md5,
        soundId: sound.soundId,
        asset: sound.asset,
      });
    })
    .catch((err) => {
      console.error(`Error decoding soundPlayer for sound: ${sound.name}`, err);
    });
}

module.exports = addSoundToSprite;
